<template>
  <ais-toggle-refinement :attribute="filter.id" :label="filter.label">
    <template v-slot="{ value, refine }">
      <div class="toggle-filter">
        <label class="toggle">
          <span
            :class="{'toggle-option': true, checked: value.isRefined}"
          >
            {{ 'Yes' | t }}
          </span>
          <div class="switch">
            <input
              type="checkbox"
              :checked="value.isRefined"
              @change="refine(value)"
              @click="scrollToTopAfterFilterChange"
            />
            <span class="slider"></span>
          </div>
        </label>
      </div>
    </template>
  </ais-toggle-refinement>
</template>

<script>
import t from '../../main/i18n';
import {transformItems, scrollToTopAfterFilterChange} from '../filters-config';

export default {
  props: {
    filter: {type: Object, required: true}
  },
  filters: {
    t
  },
  methods: {
    scrollToTopAfterFilterChange,
    transformItems(items) {
      return transformItems(this.filter, items);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../scss/system';

.toggle-option {
  font-weight: normal;
  font-size: 16px;

  &.checked {
    color: $color-blue-400;
  }
}

.switch {
  margin-right: 0 !important;
}

.switch input:not(:checked) + .slider::before {
  background: $color-gray-700;
}

.toggle {
  display: flex;
  align-items: center;
  margin-top: 1em;

  &::before,
  &::after {
    content: none;
  }
}
</style>
